
import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

const Profile: React.FC = () => {
    const { accounts } = useMsal();
    const account = accounts[0];

    useEffect(() => {
        if (account && account.idTokenClaims) {
            const claims = account.idTokenClaims;

            console.log('User Account Details:', account);
            console.log('Username (Preferred):', account.username);
            console.log('Full Name:', account.name);
            console.log('ID Token Claims:', claims);
            
            if ('roles' in claims) {
                console.log('User Roles (if any):', claims.roles);
            }

            // Use the non-null assertion operator (!) after the property name
            if ('iat' in claims) {
                console.log('Issued At (iat):', new Date(claims.iat! * 1000).toLocaleString());
            }

            if ('exp' in claims) {
                console.log('Expiration (exp):', new Date(claims.exp! * 1000).toLocaleString());
            }
        }
    }, [account]);

    return (
        <div>
            <h2>User Profile</h2>
            {account ? (
                <>
                    <p><strong>Name:</strong> {account.name}</p>
                    <p><strong>Username:</strong> {account.username}</p>
                    <p><strong>Home Account ID:</strong> {account.homeAccountId}</p>
                    {/* <p><strong>claims:</strong> {accounts}</p> */}
                </>
            ) : (
                <p>No user account found.</p>
            )}
        </div>
    );
};

export default Profile;